import { LegalPage } from './legal/LegalPage';
import { doc } from './legal/content/child-protection';

export const Child = () => <LegalPage doc={doc} />;
